export const formatterFieldCount = ({
  count,
  maxLength,
}: {
  value: string;
  count: number;
  maxLength?: number;
}) => `Символов: ${count}/${maxLength}`;
